import { useEffect } from "react"
import { Navigate, Outlet } from "react-router"
import { ROUTER } from "~/common/router"
import { useSessionStore } from "~/store/session"

export const AuthGuard = () => {
  const initialized = useSessionStore((state) => state.initialized)
  const openLoginModal = useSessionStore((state) => state.openLoginModal)
  const user = useSessionStore((state) => state.user)

  useEffect(() => {
    if (!initialized || user) return

    openLoginModal()
  }, [initialized, openLoginModal, user])

  if (!user) {
    if (!initialized) return null

    return (
      <Navigate
        to={ROUTER.HOME}
        replace
      />
    )
  }

  return <Outlet />
}
